// extracted by mini-css-extract-plugin
module.exports = {"btn":"IXa1","grey":"IXae-","big":"IXct","orange":"IXpb","green":"IXtt","white":"IXpd","whiteGray":"IXafb"};